import { App } from '@meronex/app';

import { setSupportContact } from '../../../../config/support';

const { server } = App;

export const siteSettingsMng = {
  getSiteSettings: async () => {
    const result = await server.call('getSiteSettings', {});
    return result;
  },
  updateSiteSettings: async ({ supportContact }) => {
    const result = await server.call('updateSiteSettings', { supportContact });
    return result;
  },
};

// Pull the saved support contact into the client-side config so every hint
// ("who do I contact?") shows the administrator's value. Failures are
// non-fatal — the bundled default stays in place.
export const loadSupportContact = async () => {
  try {
    const settings = await siteSettingsMng.getSiteSettings();
    if (settings && settings.supportContact) {
      setSupportContact(settings.supportContact);
    }
    return settings;
  } catch (e) {
    console.warn('Could not load site settings, using default support contact', e);
    return null;
  }
};
